import { Heading, Stack } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { FundraisingList } from '../../FundraisingList';

type Props = unknown;

/**
 * AdminFundraising.
 * Dashboard of the admin user.
 *
 * @returns {JSX.Element}
 */
export function AdminFundraising(): JSX.Element {
  const i18nAdminList = useTranslations('AdminList.Fundraisings');

  return (
    <Stack h="full" spacing="6">
      <Heading>{i18nAdminList('Title')}</Heading>
      <FundraisingList />
    </Stack>
  );
}

export type AdminFundraisingProps = Props;
